import styled from 'styled-components';

const MediaLibraryStyle = styled.div`
	--mediaLibraryTitleMarginTopBottom: var(--sp13x) 0 var(--sp11x) 0;
	--mediaLibraryPadding: var(--sp5x);
	--mediaLibrarySelectMarginBottom: var(--sp3x);
	--mediaLibrarySearchMarginBottom: var(--sp5x);

	--mediaLibraryItemMarginBottom: var(--sp7x);
	--mediaLibraryItemContentWrapMarginTop: var(--sp3x);
	--mediaLibraryItemTextMaxWidth: var(--sp40x);
	--mediaLibraryClearMarginTop: var(--sp1x);

	--searchHeight: var(--sp9x);

	--lottieSize: var(--sp30x);

	--searchFieldPadding: var(--sp3x);

	--searchIconsSize: var(--sp3x);
	--searchIconsWidth: var(--sp8x);

	.lottie-box {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;

		.lottie-wrap {
			margin: 0;
			width: var(--lottieSize);
		}
	}

	.ant-input-group-addon {
		height: var(--searchHeight) !important;

		svg {
			fill: var(--borderColor);
		}
	}

	.media-library-title {
		margin: var(--mediaLibraryTitleMarginTopBottom);
	}

	.ant-input-wrapper {
		display: flex;

		.ant-input-lg {
			padding: 0 var(--searchFieldPadding);
		}

		.ant-input-group-addon {
			width: fit-content;
			left: unset;

			.ant-btn {
				height: 100%;
			}
		}
	}

	.media-library-filter-wrap {
		height: fit-content;
		padding: var(--mediaLibraryPadding);
		background-color: var(--primaryColor3);
		border-radius: var(--sp1x);

		.media-library-search {
			.ant-input {
				font-size: var(--sp2x);

				&::placeholder {
					color: var(--borderColor);
				}
			}
		}

		.search-field-container {
			position: relative;
			margin-bottom: var(--mediaLibrarySearchMarginBottom);

			.media-library-search {
				.ant-input-wrapper {
					display: flex;

					input {
						font-size: var(--sp2x) !important;
					}

					.ant-input-group-addon {
						display: flex;
						font-size: var(--searchIconsSize);
						width: var(--searchIconsWidth);
						padding: 0;
						border: none;

						.ant-input-search-button {
							flex: 1;
							width: var(--searchIconsWidth);
							height: 100%;

							svg {
								opacity: 1;
								transition: opacity var(--trTime);
								pointer-events: all;
							}
						}
					}
				}
			}

			.search-clear {
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				width: var(--searchIconsWidth);
				font-size: var(--searchIconsSize);
				display: flex;
				align-items: center;
				justify-content: center;
				opacity: 0;
				pointer-events: none;
				transition: opacity var(--trTime);
			}

			.ant-btn-icon-only.ant-btn-lg > * {
				font-size: var(--searchIconsSize) !important;
			}

			&.disable-search-button {
				.media-library-search {
					.ant-input-wrapper {
						.ant-input-group-addon {
							.ant-input-search-button svg {
								opacity: 0;
								pointer-events: none;
							}
						}
					}
				}

				.search-clear {
					opacity: 1;
					pointer-events: all;
					cursor: pointer;
				}
			}
		}

		.media-library-select {
			margin-bottom: var(--mediaLibrarySelectMarginBottom);
		}

		.media-library-clear {
			margin-top: var(--mediaLibraryClearMarginTop);

			button {
				span {
					font-family: var(--ping);
					font-weight: 600;
					font-size: var(--sp2x);
				}
			}
		}
	}

	.media-library-item {
		margin-bottom: var(--mediaLibraryItemMarginBottom);

		&.pdf {
			.image-and-layer-wrap {
				.media-library-item-image {
					padding-top: 130%;
				}
				.icon-wrap {
					padding-top: 130%;
				}
			}
		}

		&.image {
			.image-and-layer-wrap {
				.media-library-item-image {
					padding-top: 100%;
				}
				.icon-wrap {
					padding-top: 100%;
				}
			}
		}

		.image-and-layer-wrap {
			position: relative;

			.media-library-item-image {
				&.all-filter-size {
					padding-top: 100%;
				}
			}

			&.no-hover {
				&:before {
					opacity: 40%;
				}

				.preview-button {
					opacity: 1;
				}
			}

			.icon-wrap {
				display: flex;
				justify-content: center;
				align-items: center;
				background-color: var(--secondaryColor4);
				border-radius: var(--sp2x);
				padding-top: 56%;
				height: 100%;

				.file-icon {
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					font-size: var(--sp13x);
				}
			}

			&:before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				display: flex;
				justify-content: center;
				align-items: center;
				background-color: var(--primaryColor1);
				opacity: 0;
				width: 100%;
				height: 100%;
				border-radius: var(--sp2x);
				z-index: 2;
				transition: var(--trTime);
			}

			.preview-button {
				z-index: 3;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				display: flex;
				justify-content: center;
				opacity: 0;
				transition: var(--trTime);
				min-width: 100%;
			}
		}

		@media (hover: hover) {
			&:hover {
				.image-and-layer-wrap {
					&:before {
						opacity: 40%;
					}

					.preview-button {
						opacity: 1;
					}
				}
			}
		}

		.media-library-item-image {
			padding-top: 56%;

			img {
				border-radius: var(--sp2x);
			}
		}

		.media-library-item-content-wrap {
			display: flex;
			justify-content: space-between;
			margin-top: var(--mediaLibraryItemContentWrapMarginTop);

			.file-type {
				opacity: 60%;
			}

			.media-library-item-text {
				max-width: var(--mediaLibraryItemTextMaxWidth);
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--mediaLibraryTitleMarginTopBottom: var(--sp10x) 0 var(--sp8x) 0;
		--mediaLibraryPadding: var(--sp4x);
		--mediaLibrarySelectMarginBottom: var(--sp2x);
		--mediaLibrarySearchMarginBottom: var(--sp4x);
		--mediaLibraryItemMarginBottom: var(--sp6x);
		--mediaLibraryItemContentWrapMarginTop: var(--sp2x);
		--mediaLibraryItemTextMaxWidth: var(--sp32x);

		--searchHeight: var(--sp6x);
		--lottieSize: var(--sp25x);

		--searchFieldPadding: var(--sp2x);

		--searchIconsSize: var(--sp2-5x);
		--searchIconsWidth: var(--sp6x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--mediaLibraryTitleMarginTopBottom: var(--sp8x) 0 var(--sp6x) 0;
		--mediaLibraryPadding: var(--sp4x);
		--mediaLibrarySelectMarginBottom: var(--sp2x);
		--mediaLibrarySearchMarginBottom: var(--sp4x);
		--mediaLibraryItemMarginBottom: var(--sp5x);
		--mediaLibraryItemContentWrapMarginTop: var(--sp2x);
		--mediaLibraryItemTextMaxWidth: var(--sp24x);

		--searchHeight: var(--sp6x);
		--lottieSize: var(--sp22x);

		--searchFieldPadding: var(--sp2x);

		--searchIconsSize: var(--sp2-5x);
		--searchIconsWidth: var(--sp6x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--mediaLibraryTitleMarginTopBottom: var(--sp8x) 0 var(--sp6x) 0;
		--mediaLibraryPadding: var(--sp4x);
		--mediaLibrarySelectMarginBottom: var(--sp2x);
		--mediaLibrarySearchMarginBottom: var(--sp4x);
		--mediaLibraryItemMarginBottom: var(--sp5x);
		--mediaLibraryItemContentWrapMarginTop: var(--sp2x);
		--mediaLibraryItemTextMaxWidth: var(--sp22x);

		--searchHeight: var(--sp6x);
		--lottieSize: var(--sp22x);

		--searchFieldPadding: var(--sp2x);

		--searchIconsSize: var(--sp2-5x);
		--searchIconsWidth: var(--sp6x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--mediaLibraryTitleMarginTopBottom: var(--sp7x) 0 var(--sp5x) 0;
		--mediaLibraryPadding: var(--sp3x);
		--mediaLibrarySelectMarginBottom: var(--sp1-5x);
		--mediaLibrarySearchMarginBottom: var(--sp3x);
		--mediaLibraryItemMarginBottom: var(--sp4x);
		--mediaLibraryItemContentWrapMarginTop: var(--sp2x);
		--mediaLibraryItemTextMaxWidth: var(--sp22x);

		--searchHeight: var(--sp5x);
		--lottieSize: var(--sp20x);

		--searchFieldPadding: var(--sp1-5x);

		--searchIconsSize: var(--sp2-5x);
		--searchIconsWidth: var(--sp5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--mediaLibraryTitleMarginTopBottom: var(--sp5x) 0 var(--sp4x) 0;
		--mediaLibraryPadding: var(--sp3x);
		--mediaLibrarySelectMarginBottom: var(--sp1-5x);
		--mediaLibrarySearchMarginBottom: var(--sp3x);
		--mediaLibraryItemMarginBottom: var(--sp4x);
		--mediaLibraryItemContentWrapMarginTop: var(--sp2x);
		--mediaLibraryItemTextMaxWidth: var(--sp16x);

		--searchHeight: var(--sp5x);
		--lottieSize: var(--sp18x);

		--searchFieldPadding: var(--sp1-5x);

		--searchIconsSize: var(--sp2x);
		--searchIconsWidth: var(--sp5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--mediaLibraryTitleMarginTopBottom: var(--sp5x) 0 var(--sp4x) 0;
		--mediaLibraryPadding: var(--sp3x);
		--mediaLibrarySelectMarginBottom: var(--sp1-5x);
		--mediaLibrarySearchMarginBottom: var(--sp3x);
		--mediaLibraryItemMarginBottom: var(--sp4x);
		--mediaLibraryItemContentWrapMarginTop: var(--sp2x);
		--mediaLibraryItemTextMaxWidth: var(--sp22x);

		--searchHeight: var(--sp5x);
		--lottieSize: var(--sp18x);

		--searchFieldPadding: var(--sp1-5x);

		--searchIconsSize: var(--sp2x);
		--searchIconsWidth: var(--sp5x);

		.items-wrap {
			margin-top: var(--sp5x);
		}

		.lottie-box {
			margin-top: var(--sp8x);
		}
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--mediaLibraryTitleMarginTopBottom: var(--sp5x) 0 var(--sp4x) 0;
		--mediaLibraryPadding: var(--sp3x);
		--mediaLibrarySelectMarginBottom: var(--sp1-5x);
		--mediaLibrarySearchMarginBottom: var(--sp3x);
		--mediaLibraryItemMarginBottom: var(--sp4x);
		--mediaLibraryItemContentWrapMarginTop: var(--sp2x);
		--mediaLibraryItemTextMaxWidth: var(--sp22x);

		--searchHeight: var(--sp5x);
		--lottieSize: var(--sp14x);

		--searchFieldPadding: var(--sp1-5x);

		--searchIconsSize: var(--sp2x);
		--searchIconsWidth: var(--sp5x);

		.items-wrap {
			margin-top: var(--sp5x);
		}

		.lottie-box {
			margin-top: var(--sp7x);
		}

		.media-library-filter-wrap {
			.media-library-search {
				.ant-input-wrapper {
					.ant-input {
						font-size: var(--sp2x);
					}
				}
			}
		}
	}
`;

export default MediaLibraryStyle;
